module.exports = __webpack_public_path__ + "root-2bf1921b/Background_01_7x2_a-863d5f3ac02162689146d27bef34552b.svg";